import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
const names = ['María', 'Camila', 'Florencia', 'Sofía', 'Valentina', 'Julieta', 'Martina', 'Luciana', 'Agustina', 'Carolina', 'Daniela', 'Paula', 'Natalia', 'Gabriela', 'Andrea'];
const cities = ['Buenos Aires', 'Córdoba', 'Rosario', 'Mendoza', 'Tucumán', 'La Plata', 'Mar del Plata', 'Salta', 'Santa Fe', 'Neuquén'];
function getRandom<T>(arr: T[]): T {
  return arr[Math.floor(Math.random() * arr.length)];
}
export function SocialProofPopup() {
  const [visible, setVisible] = useState(false);
  const [person, setPerson] = useState({
    name: '',
    city: ''
  });
  useEffect(() => {
    const showPopup = () => {
      setPerson({
        name: getRandom(names),
        city: getRandom(cities)
      });
      setVisible(true);
      setTimeout(() => setVisible(false), 4000);
    };
    const initialTimeout = setTimeout(showPopup, 10000);
    const interval = setInterval(showPopup, 30000);
    return () => {
      clearTimeout(initialTimeout);
      clearInterval(interval);
    };
  }, []);
  return <AnimatePresence data-id="element-275">
      {visible && <motion.div initial={{
      x: -300,
      opacity: 0
    }} animate={{
      x: 0,
      opacity: 1
    }} exit={{
      x: -300,
      opacity: 0
    }} transition={{
      type: 'spring',
      stiffness: 120,
      damping: 18
    }} className="fixed top-12 left-4 z-50 max-w-xs" data-id="element-276">
          <a href="#compra" className="block" data-id="element-277">
            <div className="bg-white border border-brand-gray rounded-[16px] p-4 shadow-[0_8px_32px_rgba(0,0,0,0.12)]" data-id="element-278">
              <div className="flex items-center gap-3" data-id="element-279">
                <div className="w-10 h-10 rounded-full bg-brand-violet/10 flex items-center justify-center text-lg flex-shrink-0" data-id="element-280">
                  🛒
                </div>
                <div data-id="element-281">
                  <p className="text-brand-text text-[14px] font-bold leading-tight" data-id="element-282">
                    {person.name} de {person.city}
                  </p>
                  <p className="text-brand-muted text-[12px] mt-0.5" data-id="element-283">
                    acaba de comprar el Método pH-ZERO
                  </p>
                  <p className="text-brand-violet text-[10px] font-bold mt-1" data-id="element-284">
                    Hace unos momentos
                  </p>
                </div>
              </div>
            </div>
          </a>
        </motion.div>}
    </AnimatePresence>;
}